import React from 'react';
import {Link} from "react-router-dom";

const ToastWithLink = ({ message }) => {
    return (
        <div>
            <span dangerouslySetInnerHTML={{ __html: message }} />
        </div>
    );
};

export default ToastWithLink;